<template>
  <div class="horizontalScroll">
    <v-sheet width="100%" min-width="500">
      <TreeViewRoot
        :key="key"
        v-if="items"
        :items="items"
        :opened="opened"
        :on-change-open="openChildren"
        :on-create="onCreateItem"
        :on-save="onSaveItem"
        :on-delete="onDeleteItem"
        :refresh-tree="refreshTree"
        :get-items="getItems"
      />
    </v-sheet>
  </div>
</template>

<script>
import TreeViewRoot from "components/base/treeview/TreeViewRoot";

export default {
  name: "BaseTreeView",
  components: {TreeViewRoot},
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    getItems: {},
    onCreateItem: {},
    onSaveItem: {},
    onDeleteItem: {},
  },
  data: () => ({
    key: 0,
    opened: [],
  }),
  mounted() {
    this.prepareData()
  },
  methods: {
    prepareData() {
      this.opened = []
      this.test(this.items, null)
      this.key++
    },
    
    test(items, parent) {
      for (let i in items) {
        this.opened.push(items[i].id)
        if (parent) items[i].parent = parent
        this.test(items[i].children, items[i].id)
      }
    },
    
    openChildren(id) {
      let index = this.opened.indexOf(id)
      if (index > -1) this.opened.splice(index, 1)
      else this.opened.push(id)
      this.key++
    },
    
    refreshTree() {
      this.key++
    }
  }
}
</script>

<style scoped lang="scss">
.horizontalScroll {
  @media #{map-get($display-breakpoints, 'xs-only')} {
    overflow-x: scroll;
    max-width: 93vw
  }
}
</style>
